'use strict';

exports.__esModule = true;

var _observableConstructor = require('./observableConstructor');

var _defineObservableSymbol = require('./defineObservableSymbol');

var _defineObservableSymbol2 = _interopRequireDefault(_defineObservableSymbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Generated by CoffeeScript 1.12.6
var defineObservable,
    hasProp = {}.hasOwnProperty;

exports.default = defineObservable = function (opts) {
  var constr, k, observable, originalSubscriber, subscriber, v;
  constr = (0, _observableConstructor.getObservableConstructor)();
  if (constr) {
    originalSubscriber = opts.subscribe;
    subscriber = function (observer) {
      var subscription;
      subscription = originalSubscriber(observer);
      return function () {
        return subscription.unsubscribe();
      };
    };
    observable = new constr(subscriber);
    for (k in opts) {
      if (!hasProp.call(opts, k)) continue;
      v = opts[k];
      if (k !== 'subscribe') {
        observable[k] = v;
      }
    }
    return observable;
  } else {
    return (0, _defineObservableSymbol2.default)(opts);
  }
};